import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconShareComponent } from "./med-icon-share.component";

@NgModule({
  declarations: [
    MedIconShareComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconShareComponent,
  ],
})
export class MedIconShareModule { }
